import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoIosEye, IoMdDownload } from "react-icons/io";
import { FaSmile, FaTimes, FaCheck } from "react-icons/fa";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from '../../../components/Loader';
import moment from 'moment';
import getExcel from "../../../_services/ExcelUtility";
const FileProcessStatusReportPage = (props) => {
    const fileName = 'File Process Status report'
    const [startDate, setStartDate] = useState(new Date());
    const [errorFiles, setErrorFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    let filterStartDate = moment(startDate).format("L")
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [emptyErr, setEmptyErr] = useState(false)
    const [taskType, setTaskType] = useState(0)
    const [show, setShow] = useState(false);
    const [fileFormat, setFileFormat] = useState(0);
    const [errorDetails, setErrorDetails] = useState([]);
    const [taskList, setTaskDownList] = useState([])
    const [fileStatusReportError, setFileStatusReportError] = useState(false)
    const [viewFileStatusReportError, setViewFileStatusReportError] = useState(false)

    const columns = [
        {
            Header: "Errors / Comments",
            accessor: 'accessor',
            disableFilters: true,
            disableSortBy: true,
            width:150,
            Cell: ({ row: { original } }) => (
                <Fragment>
                    {original.ErrorDescription == "N/A" || original.ErrorDescription == null ? "N/A" : <Button variant="link" onClick={() => viewErrors(original.FileProcessId)} className="grid-action-btn ml-2" title="View Task">
                        <IoIosEye className="icon" />
                    </Button>}
                </Fragment>
            )
        },
        {
            Header: "Task Name",
            accessor: "TaskName",
            filter: "TaskName",
            sortType: "basic",
            width: 200
        },
        {
            Header: "File Name",
            accessor: "FileName",
            filter: "FileName",
            sortType: "basic", width: 270,
            Cell: ({ row: { original } }) => (
                <Fragment>
                    <span className="word-wrap">{original.FileName}</span>
                </Fragment>
            )
        },
        {
            Header: "Source",
            accessor: "Source",
            filter: "Source",
            sortType: "basic", width: 120
        },
        {
            Header: "File Received/Generated Timestamp",
            accessor: "FileProcessRcvdDate",
            filter: "FileProcessRcvdDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Process Start Timestamp",
            accessor: "FileProcessStartDate",
            filter: "FileProcessStartDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Process End Timestamp",
            accessor: "FileProcessEndDate",
            filter: "FileProcessEndDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Elapsed Time",
            accessor: "ElapsedTime",
            filter: "ElapsedTime",
            sortType: "basic", width: 180
        },
        {
            Header: "File Size",
            accessor: "FileSize",
            filter: "FileSize",
            sortType: "basic", width: 90,
            Cell: ({row: {original}}) => (
                <Fragment>
                    <span>{formatFileSize(original.FileSize)}</span>
                </Fragment>
            )
        },
        {
            Header: "Row Count",
            accessor: "FileRowCount",
            filter: "FileRowCount",
            sortType: "basic", width: 120
        },
        {
            Header: "Status",
            accessor: "Status",
            disableFilters: true,
            disableSortBy: true, width: 140,
            Cell: ({ row: { original } }) => (
                <Fragment>

                    {original.Status === "ReadyForProcess" || original.Status === "InProcess" || original.Status === "QueuedForStaging" || original.Status === "StageCopyInProgress" || original.Status === "ReadyForStageQueue" ?
                        <Fragment>
                            <FaCheck  title="In Progress" style={{ fontSize: '20px', color: '#236f16' }} />
                        </Fragment>
                        : null}
                    {original.Status === "ProcessSuccess" || original.Status === "Acknowledged" ?
                        <Fragment>
                            <FaSmile title="Success" style={{ fontSize: '20px', color: '#236f16' }} />
                        </Fragment>
                        : null}
                    {original.Status === "StageCopyFailed" || original.Status === "ProcessFail" || original.Status === "Duplicate" ?
                        <Fragment>
                            <FaTimes title="Failed" style={{ fontSize: '20px', color: '#f11f0f' }} />
                        </Fragment>
                        : null}
                </Fragment>
            )
        }
    ];

    const errorDetaileColumns = [
        {
            Header: "Timestamp",
            accessor: "ErrorCreatedDate",
        },
        {
            Header: "File Name",
            accessor: "FileProcessName",
        },
        {
            Header: "Error Description",
            accessor: "ErrorDescription",
        },
    ]

    useEffect(() => {
        GetFileProcessStatusReports();
    }, [])

    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
            setValidated(true)
        } else {
            e.preventDefault()
            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = moment(startDate).format("L")

            GetFileProcessStatusReports()

            setBtnDisable(true)
            setValidated(false)
        }
    }

    const GetFileProcessStatusReports = () => {
        setLoading(true);
        _HttpServices
            .getData(`api/chart/GetFileProcessReport?Taskdate=${filterStartDate}&FileSourceType=${taskType}&FileFormat=${fileFormat}`)
            .then((data) => {
                const errorsFileResult = data.data;
                if (errorsFileResult.length > 0) {
                    errorsFileResult.map((res) => {
                        res.FileProcessRcvdDate = moment(res.FileProcessRcvdDate).format('MM/DD/YYYY h:mm:ss A')
                        res.FileProcessStartDate = moment(res.FileProcessStartDate).format('MM/DD/YYYY h:mm:ss A')
                        res.FileProcessEndDate = res.FileProcessEndDate ? moment(res.FileProcessEndDate).format('MM/DD/YYYY h:mm:ss A') : res.FileProcessEndDate
                        // res.FileSize = formatFileSize(res.FileSize);
                    })
                }
                setErrorFiles(errorsFileResult);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setFileStatusReportError(true)
            });


    };

    // Format file size to kb
    const formatFileSize = (bytes) => {
        if(bytes === 0 || bytes === null){
            let size  = 0 + ' ' + 'Bytes';
            return size;
          } else {            
            var k = 1000,
                dm = 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
          }
    }

    const viewErrors = (fileProcessID) => {
        setShow(true);
        setLoading(true);
        _HttpServices
            .getData(`Api/Chart/GetFileProcessesErrors?processesID=${fileProcessID}`)
            .then((data) => {
                const errorDetails = data.data;
                if (errorDetails.length > 0) {
                    errorDetails.map((res) => {
                        res.ErrorCreatedDate = moment(res.ErrorCreatedDate).format('MM/DD/YYYY h:mm:ss A')
                    })
                }
                setErrorDetails(errorDetails);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setViewFileStatusReportError(true)
            });
    }
    const handleClose = () => setShow(false);
    return (
        <Row>
            <Col md={12}>
                <div className="card pt-2 mb-4">
                    <div className="card-body">
                        {errorFiles.length > 0 ?
                            <Button type="submit" className="dashboard-excel-btn" onClick={() => getExcel(columns, errorFiles, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                            : null}
                        <Form noValidate validated={validated} onSubmit={submitHandler}>
                            <Row>
                                <Col md={3}>
                                    <Form.Group>
                                        <div className="date-picker ungroup-date-picker pos-rl">
                                            <Form.Label htmlFor="StartDate">
                                                Date
                                            </Form.Label>
                                            <IoMdCalendar className="icon date-icon" />
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    if (date) {
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    } else {
                                                        setBtnDisable(true)
                                                    }

                                                }}
                                                maxDate={new Date()}
                                                required className={emptyErr ? "form-control is-invalid" : "form-control"}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="formLastName">
                                        <Form.Label>
                                            Select Type
                                </Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="taskType"
                                            type="text"
                                            value={taskType}
                                            onChange={e => {
                                                setBtnDisable(false)
                                                return setTaskType(e.target.value)
                                            }}>

                                            <Fragment>

                                                <option id="0" value="0">All</option>
                                                <option id="1" value="1">All In-bound </option>
                                                <option id="2" value="2">All Out-bound.</option>
                                                {props.tasks.map(item =>
                                                    <option key={item.Id} value={item.Id}>{item.TaskName}</option>
                                                )}
                                            </Fragment>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="formLastName">
                                        <Form.Label>
                                            Select Format
                                </Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="fileFormat"
                                            type="text"
                                            value={fileFormat}
                                            onChange={e => {
                                                setBtnDisable(false)
                                                return setFileFormat(e.target.value)
                                            }}>

                                            <Fragment>
                                                <option id="0" value="0">All</option>
                                                <option value="1">Edi File</option>
                                                <option value="2">Flat File</option>
                                                <option value="3">Json</option>
                                                <option value="4">Excel </option>
                                                <option value="5">PDF </option>

                                            </Fragment>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group className="mt-2">
                                        <Button type="submit" className="mt-3"
                                            disabled={btnDisable}
                                        >
                                            <IoMdDoneAll className="icon btn-icon" />
                                            Submit
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
                <div className="card pt-2">
                    <div className="card-body">
                        <div className="inventory-grid">
                            <Fragment>
                                {loading ? <Loader /> : errorFiles.length > 0 ? (
                                    <ReactTable columns={columns} data={errorFiles} defaultPageSize={10} />
                                ) : fileStatusReportError ? <p>Error occurred. Unable to load file status reports.</p> : (
                                    <div className="no-data">No data found.</div>
                                )}
                            </Fragment>
                        </div>
                    </div>
                </div>

                {/* model */}
                <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
                    <Modal.Header closeButton>
                    <h4 className="h4">View Error</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="card pt-2">
                            <div className="card-body">
                                <div className="queue-files-grid">
                                    <Fragment>
                                        {loading ? <Loader /> : errorDetails.length > 0 ? (
                                            <ReactTable columns={errorDetaileColumns} data={errorDetails} defaultPageSize={10} />
                                        ) : viewFileStatusReportError ? <p>Error occurred. Unable to load view file status reports.</p> : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                    </Fragment>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>

                </Modal>
            </Col>

        </Row>
    )
}

export default FileProcessStatusReportPage;